import React from 'react';
import styled from 'styled-components';
import filterIcon from 'images/Filter.png';

export default function CommunityFilter({onClickFilter}) {
    return (
        <FilterSection>
            <FilterButtonWrapper onClick={onClickFilter}>
                <FilterIconBlock>
                    <FilterIcon src={filterIcon} />
                </FilterIconBlock>
                <FilterText>Filter</FilterText>
            </FilterButtonWrapper>
        </FilterSection>
    );
}

const FilterSection = styled.div`
    display: flex;
    justify-content: flex-end;
    padding-bottom: calc(100vw * (6 / 375));
`;

const FilterButtonWrapper = styled.div`
    display: flex;
    align-items: center;
`;

const FilterIconBlock = styled.span`
    width: calc(100vw * (8.4 / 375));
    height: calc(100vw * (11.3 / 375));
`;

const FilterIcon = styled.img`
    width: 100%;
    object-fit: cover;
`;

const FilterText = styled.span`
    font-size: calc(100vw * (12 / 375));
    font-weight: 500;
    line-height: 1.5;
    color: #7f7f7f;
    margin-left: calc(100vw * (3.2 / 375));
`;